import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "col-lg-6" }
const _hoisted_5 = { class: "col-lg-6" }
const _hoisted_6 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing" }
const _hoisted_8 = {
  id: "projectDistributionChart",
  class: "chart"
}
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatsCaDerniersJours = _resolveComponent("StatsCaDerniersJours")!
  const _component_StatCaDesAbonnementAnnee = _resolveComponent("StatCaDesAbonnementAnnee")!
  const _component_WebsiteVisitors = _resolveComponent("WebsiteVisitors")!
  const _component_ChartJsChart = _resolveComponent("ChartJsChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_StatsCaDerniersJours)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_StatCaDesAbonnementAnnee)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_WebsiteVisitors)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "mb-15 d-flex align-items-center justify-content-between" }, [
            _createElementVNode("h5", { class: "card-title fw-bold mb-0" }, "Etat d'abonnement")
          ], -1)),
          _createElementVNode("div", _hoisted_8, [
            (_ctx.chartDat)
              ? (_openBlock(), _createBlock(_component_ChartJsChart, {
                  key: 0,
                  chartData: _ctx.chartDat,
                  chartOptions: _ctx.chartOptions
                }, null, 8, ["chartData", "chartOptions"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, "Loading..."))
          ])
        ])
      ])
    ])
  ]))
}